import { ref } from "vue";
import { getOrganisationPreview, } from "../infrastructure/adapters/organisationService";
import { logger } from "../../../infrastructure/services/LoggerService";
const EstablishmentNatureThemeMap = {
    Headquarters: "indigo",
    Subsidiary: "purple",
    Branch: "green",
    RepresentativeOffice: "red",
};
export function getEstablishmentNatureTheme(tag) {
    return EstablishmentNatureThemeMap[tag] ?? "neutral";
}
export function useOrganisationPreview() {
    const showPreviewDrawer = ref(false);
    const previewOrg = ref(null);
    const previewLoading = ref(false);
    const previewName = ref();
    async function openPreviewDrawer(result) {
        previewOrg.value = null;
        previewName.value = result.legalName;
        showPreviewDrawer.value = true;
        previewLoading.value = true;
        try {
            previewOrg.value = await getOrganisationPreview(result.id);
        }
        catch (error) {
            logger.error("Failed to load organisation preview", error);
            showPreviewDrawer.value = false;
        }
        finally {
            previewLoading.value = false;
        }
    }
    function reset() {
        showPreviewDrawer.value = false;
        previewOrg.value = null;
        previewLoading.value = false;
        previewName.value = undefined;
    }
    return { showPreviewDrawer, previewOrg, previewLoading, previewName, openPreviewDrawer, reset };
}
